export const LIQUIBASE_LABEL = '[NODE-LIQUIBASE]';
